import { render, staticRenderFns } from "./goodscommon.vue?vue&type=template&id=07b40998&scoped=true&"
import script from "./goodscommon.vue?vue&type=script&lang=js&"
export * from "./goodscommon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b40998",
  null
  
)

export default component.exports